var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComponent2751(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_275_1",
    "data-name": "Component 275 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5924",
    "data-name": "Rectangle 5924",
    width: 32,
    height: 32,
    rx: 5,
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-share-link-875784",
    transform: "translate(9.484 9.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3356",
    "data-name": "Group 3356"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3355",
    "data-name": "Group 3355"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32239",
    "data-name": "Path 32239",
    d: "M432.61,220.888v0h-4.833a1.892,1.892,0,0,0-1.884,1.887v9.471a1.889,1.889,0,0,0,1.887,1.887h9.471a1.892,1.892,0,0,0,1.887-1.892V228.44h0a.946.946,0,0,1,1.892,0h0v3.806a3.784,3.784,0,0,1-3.78,3.784H427.78a3.782,3.782,0,0,1-3.78-3.78V222.78a3.785,3.785,0,0,1,3.776-3.78h4.833v0a.946.946,0,0,1,0,1.883Zm2.372,6.729,1.171,1.171-2.967,2.967c-1.052,1.052-2.871.708-4.131-.552s-1.6-3.08-.555-4.128l2.97-2.97,1.171,1.171-2.97,2.97c-.266.266-.11,1.084.574,1.767s1.5.842,1.771.571Zm2.363-.021-1.171-1.171,2.967-2.967c.271-.271.118-1.082-.571-1.771s-1.5-.84-1.768-.574l-2.97,2.97-1.171-1.171,2.97-2.97c1.048-1.048,2.874-.7,4.128.555s1.6,3.079.552,4.131Zm-2.327-3.527a.828.828,0,1,1,1.171,1.171l-2.39,2.39a.828.828,0,1,1-1.171-1.171Z",
    transform: "translate(-424 -219)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent2751);
export default __webpack_public_path__ + "static/media/Component 275 – 1.db299d8db6f011d64b58c423a8f8dc27.svg";
export { ForwardRef as ReactComponent };